import Vue from "vue";
import Vuex from "vuex";

import auth from "./auth.module";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

/**
 * Amplify Logger 代替のシンプル Logger
 * - 既存の logger.error / info / debug 呼び出し互換
 * - 本番・開発で差し替えやすい
 */
const logger = {
  error: (...args) => console.error("[LECO][ERROR]", ...args),
  warn: (...args) => console.warn("[LECO][WARN]", ...args),
  info: (...args) => console.info("[LECO][INFO]", ...args),
  debug: (...args) => {
    if (process.env.NODE_ENV !== "production") {
      console.debug("[LECO][DEBUG]", ...args);
    }
  },
  verbose: (...args) => {
    if (process.env.NODE_ENV !== "production") {
      console.debug("[LECO][VERBOSE]", ...args);
    }
  }
};

export default new Vuex.Store({
  state: {
    logger
  },
  modules: {
    auth
  },
  plugins: [
    createPersistedState({
      key: "LecoApp",
      paths: ["auth.user", "auth.isAuthenticated"],
      storage: window.sessionStorage
    })
  ]
});
